"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PatientInfoItem = PatientInfoItem;
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Text = _typography.default.Text;
function PatientInfoItem(_ref) {
  var label = _ref.label,
    value = _ref.value,
    _ref$labelColSpan = _ref.labelColSpan,
    labelColSpan = _ref$labelColSpan === void 0 ? 7 : _ref$labelColSpan,
    _ref$valueColSpan = _ref.valueColSpan,
    valueColSpan = _ref$valueColSpan === void 0 ? 16 : _ref$valueColSpan,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 1 : _ref$offset,
    imageId = _ref.imageId;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isImage = _useState2[0],
    setIsImage = _useState2[1];
  return /*#__PURE__*/_react.default.createElement(_row.default, {
    className: "patientInfoItem"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    span: labelColSpan
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "card-label"
  }, label)), /*#__PURE__*/_react.default.createElement(_col.default, {
    offset: offset,
    span: valueColSpan
  }, imageId ? isImage ? /*#__PURE__*/_react.default.createElement("img", {
    src: (0, _utils.getAccountImageUrl)(imageId),
    alt: "",
    className: "w-[inherit] h-auto",
    onError: function onError() {
      setIsImage(false);
    }
  }) : /*#__PURE__*/_react.default.createElement("a", {
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    href: "".concat((0, _utils.getAccountImageUrl)(imageId), "?content=pdf"),
    target: "_blank",
    rel: "noopener noreferrer"
  }, "View ID Card") : /*#__PURE__*/_react.default.createElement(Text, null, value || '-')));
}
PatientInfoItem.propTypes = {
  label: _propTypes.default.string.isRequired,
  value: _propTypes.default.any,
  labelColSpan: _propTypes.default.number,
  valueColSpan: _propTypes.default.number,
  offset: _propTypes.default.number,
  imageId: _propTypes.default.string
};